<template>
  <div class="pl-6 pt-6">
    <div class="text-lg text-blue-500 text-left w-full border-b-2 border-solid">Other Available Distributions</div>
  </div>
  <div class="pl-6 pt-3">
    <div v-for="dist in resource.distribution">
      <div class="flex flex-row gap-3 p-2">
        <div class="flex-col text-right w-1/6 uppercase text-gray-700 text-sm">{{ dist.title }}</div>
        <div class="flex-col text-xs w-3/4 text-left border-solid border-l-2 pl-2 align-text-bottom text-gray-700">
          <div>
            FORMAT: <span class="text-gray-500">{{ dist.format }}</span>
          </div>
          <div>
            MEDIA TYPE: <span class="text-gray-500">{{ dist.mediaType }}</span>
          </div>
          <div v-if="dist.description">{{ dist.description }}</div>
          <a v-if="dist.accessURL" class="text-blue-500 text-xs" :href="dist.accessURL"
            ><span class="text-gray-700">URL:</span> {{ dist.accessURL }}</a
          >
          <a v-if="dist.downloadUrl" class="text-blue-500 text-xs" :href="dist.downloadUrl"
            ><span class="text-gray-700">DOWNLOAD URL:</span> {{ dist.downloadUrl }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Distributions',
  props: {
    resource: {
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
